/**
 * Version of the sibling `beckhoff-xts-viewer-3d-assets` GLB package
 * this viewer build targets.
 *
 * Auto-written at build time by `scripts/sync-assets-cdn-version.mjs`
 * — reads `packages/assets/package.json` (the source of truth for the
 * assets release line) and writes this file. The prebuild npm script
 * keeps it in sync before every viewer publish.
 *
 * The assets package now releases independently from the viewer (only
 * when GLB files actually change), so this version generally diverges
 * from the viewer's own VERSION over time. The default
 * `assetsBaseUrl` (see ./cdnUrl.ts) pins to this exact version so a
 * `viewer@x.y.z` install always streams from a known-compatible GLB
 * release on the CDN.
 *
 * DO NOT EDIT BY HAND — re-run `npm run sync-assets-cdn-version`
 * (or any build script) to regenerate.
 */

export const ASSETS_VERSION = '0.3.1' as const;
